import { Button, Chip, Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import ToolTip from "../../../ToolTip/ToolTip";
import { render } from "@testing-library/react";
import CloseAccounts from "../../../../views/crd/myworkspace/NewAdmissionRegister/components/CloseAccount";

export const Ledger_Table_Head = (
  admissionNo,
  studentName,
  course,
  dispatchdata,
  OpeningBalance,
  hasUnverifiedEntries
) => [
  {
    field: "slNo",
    headerName: "Sl No",
  },
  {
    field: "date",
    headerName: "Date",
    width: 150,
  },
  {
    field: "particulars",
    headerName: "Particulars",
    width: 200,
  },
  {
    field: "income_amount",
    headerName: "Income",
    width: 150,
  },
  {
    field: "expense_amount",
    headerName: "Expense",
    width: 150,
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 250,
    renderCell: (params) => {
      if (
        params.row.close_status === "0" &&
        params.row.particulars === "Closing Balance" &&
        !hasUnverifiedEntries
      ) {
        return (
          <CloseAccounts
            studentName={studentName}
            admissionNo={admissionNo}
            course={course}
            month={params.row.month}
            year={params.row.year}
            closingBalance={params.row.expense_amount}
            courseEnrollmentId={params.row.course_enrollment_id}
            openingBalance={OpeningBalance}
            totalIncome={params.row.totalIncome}
            totalExpense={params.row.totalExpense}
            dispatchdata={dispatchdata}
          />
        );
      } else if (
        params.row.close_status === "0" &&
        params.row.particulars === "Closing Balance" &&
        hasUnverifiedEntries
      ) {
        return (
          <Button
            sx={{
              backgroundColor: "#d90429",
              color: "#fff",
              fontSize: "12px",
            }}
          >
            Payment Verification Incomplete
          </Button>
        );
      } else if (
        params.row.close_status === "1" &&
        params.row.particulars === "Closing Balance"
      ) {
        return (
          <Button
            sx={{
              backgroundColor: "#007200",
              color: "#fff",
            }}
          >
            Account Closed
          </Button>
        );
      } else {
        return params.row.notes;
      }
    },
  },
  {
    field: "tp_per_session",
    headerName: "Trainer's Payment",
    width: 200,
  },
  {
    field: "accountant_verification",
    headerName: "Account Verification",
    width: 200,
    renderCell: (params) => {
      if (params.row.accountant_verification === "1") {
        return <Chip label={"Verified"} color="success" size="small" />;
      } else if (params.row.accountant_verification === "0") {
        return <Chip label={"Not Verified"} color="error" size="small" />;
      } else {
        return null;
      }
    },
  },
];
